import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useRef } from 'react';
import { LoaderCircle, Sparkles } from 'lucide-react';

const Signup = () => {
  const { loginWithRedirect } = useAuth0();
  const hasCalled = useRef(false);

  useEffect(() => {
    if (hasCalled.current) return;
    hasCalled.current = true;
    loginWithRedirect({
      appState: {
        returnTo: '/checkout',
      },
      authorizationParams: {
        screen_hint: 'signup',
      },
    });
  }, [loginWithRedirect]);

  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4 py-10">
      <div className="surface-card w-full max-w-md p-8 text-center sm:p-10">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-midnight text-brand-volt shadow-lg">
          <Sparkles className="h-7 w-7" />
        </div>
        <p className="eyebrow mt-5">Start with a stronger week</p>
        <h1 className="mt-3 text-3xl font-bold tracking-tight text-brand-midnight">
          Creating your RaceTrainer account
        </h1>
        <p className="mt-3 text-sm leading-6 text-gray-600">
          Secure sign-up is opening now.
        </p>
        <LoaderCircle className="mx-auto mt-7 h-5 w-5 animate-spin text-brand-cobalt" />
      </div>
    </div>
  );
};

export default Signup;
